// extracted by mini-css-extract-plugin
export default {"card":"PreDilutionContent_card__8xIh9","cardContent":"PreDilutionContent_cardContent__7v67R"};